export function formatPrice(price) {
  return Number(price).toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' });
}

export function isSellOut(specInfo) {
  if(specInfo.stock > 0) {
    return false;
  } else {
    return true;
  }
}

export function payOrder(router, order) {
  const id = order.id
  router.push({name:'pay-pay', params:{ id }});
}

export function getOrderStatus(enums, order) {
  if(order.orderStatus == enums.orderStatus.COMPLETED){
    return '已完成'
  }else if(order.orderStatus == enums.orderStatus.CANCELLED){
    return '已取消'
  }else if(order.shippingStatus == enums.shippingStatus.SHIPPED){
    return '已发货'
  }else if(order.payStatus == enums.payStatus.PAID){
    return '待收货'
  }else {
    return '待付款'
  }
}

